/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowComponentCriterionDetail
 */
export interface ShadowComponentCriterionDetail {
    /**
     * 
     */
    criteria_id: string;
    /**
     * 
     */
    query: string;
    /**
     * 
     */
    result: string;
    /**
     * 
     */
    qualifier: string;
    /**
     * 
     */
    is_medication_rule: boolean;
    /**
     * 
     */
    score_contribution: number;
}

/**
 * Check if a given object implements the ShadowComponentCriterionDetail interface.
 */
export function instanceOfShadowComponentCriterionDetail(value: object): value is ShadowComponentCriterionDetail {
    if (!('criteria_id' in value) || value['criteria_id'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('is_medication_rule' in value) || value['is_medication_rule'] === undefined) return false;
    if (!('score_contribution' in value) || value['score_contribution'] === undefined) return false;
    return true;
}

export function ShadowComponentCriterionDetailFromJSON(json: any): ShadowComponentCriterionDetail {
    return ShadowComponentCriterionDetailFromJSONTyped(json, false);
}

export function ShadowComponentCriterionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowComponentCriterionDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'criteria_id': json['criteria_id'],
        'query': json['query'],
        'result': json['result'],
        'qualifier': json['qualifier'],
        'is_medication_rule': json['is_medication_rule'],
        'score_contribution': json['score_contribution'],
    };
}

export function ShadowComponentCriterionDetailToJSON(json: any): ShadowComponentCriterionDetail {
    return ShadowComponentCriterionDetailToJSONTyped(json, false);
}

export function ShadowComponentCriterionDetailToJSONTyped(value?: ShadowComponentCriterionDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criteria_id': value['criteria_id'],
        'query': value['query'],
        'result': value['result'],
        'qualifier': value['qualifier'],
        'is_medication_rule': value['is_medication_rule'],
        'score_contribution': value['score_contribution'],
    };
}

